<template>
    <div>
        <label v-if="label" :for="componentId">{{ label }}</label>
        <input @input="$emit('input', $event.target.value)"
               :id="componentId"
               :name="componentName"
               :class="{'error': errors.has(componentId)}"
               :type="type"
               :placeholder="placeholder"
               :aria-describedby="'description-' + componentId"
               :readonly="readonly"
               v-validate :data-vv-rules="validate"
               :value="value"
               :min="min"
               :max="max"
        />
        <small v-if="description" :id="'description-' + componentId" class="form-description">{{ description }}</small>
    </div>
</template>

<script>
  export default {
    name: 'InputWidget',
    inject: ['$validator'],
    props: {
      label: {
        type: String
      },
      type: {
        type: String,
        default: 'text'
      },
      id: {
        type: String
      },
      name: {
        type: String
      },
      placeholder: {
        type: String
      },
      description: {
        type: String
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      validate: {
        type: String
      },
      value: {
        type: [String, Number, Boolean]
      },
      min: {
        type: Number
      },
      max: {
        type: Number
      }
    },
    data () {
      return {
        uid: this.guid()
      }
    },
    computed: {
      componentId () {
        return this.id ? this.id : this.uid
      },
      componentName () {
        return this.name ? this.name : this.uid
      }
    },
    methods: {
      guid () {
        function s4 () {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1)
        }
        return s4() + s4() + s4()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/widgets/InputWidget.vue